import styled from 'styled-components';
import UptimeTypography from "../../commonComponents/Typography/Typography";
import UptimeCol from "../../layoutComponents/Col";
import { IThemeProps } from "component/theme";

export const StyledTypography = styled(UptimeTypography)`
    ${({ theme }: IThemeProps) => `
        color: ${theme.uptimeColors.mainTheme.primary}; 
    `}
`;

export const StyledCol = styled(UptimeCol)`
    ${({ theme }: IThemeProps) => `  
    border-right: 1px solid ${theme.colors.grayScale[4]};
    margin-bottom: ${theme.uptimeSpace[16]}px !important;
    padding: ${theme.uptimeSpace[0]} ${theme.uptimeSpace[12]}px ${theme.uptimeSpace[0]} ${theme.uptimeSpace[0]};
    @media screen and (min-width:${theme.breakpoints.lg}) {
        &:nth-child(4n+4) {
            border-right: none;
        }
    };

    @media screen and (min-width:${theme.breakpoints.md}) and (max-width:${theme.breakpoints.lg}) {
        &:nth-child(3n+3) {
            border-right: none;
        }
    };

    @media screen and (min-width:${theme.breakpoints.sm}) and (max-width:${theme.breakpoints.md}) {
        &:nth-child(2n+2) {
            border-right: none;
        }
    };

    @media screen and (min-width:${theme.breakpoints.xs}) and (max-width:${theme.breakpoints.sm}) {
        border-right: none;
    };

    @media screen and (min-width:${theme.breakpoints.xxs}) and (max-width:${theme.breakpoints.xs}) {
        border-right: none;
    };

    `}


`;